import PropTypes from 'prop-types'
import ModalActions from 'components/CommonUI/ModalActions'
import TextButton from 'components/TextButton'
import Type from 'components/Type'
import Icon from 'components/Icon'
import Stack from '@mui/material/Stack'
import ModalView from 'components/CommonUI/ModalView'
import { useAction } from 'utils/actions'

const PhotoUploadFailed = ({ reasons, reopenID }) => {
  const { closeModal } = useAction()

  const handleReopen = () => {
    closeModal()
    if (reopenID) document.getElementById(reopenID).click()
  }

  return (
    <ModalView sizeX="lg">
      <Stack display="grid" justifyItems="center" textAlign="center" py={3} px={4}>
        <Stack display="grid" justifyContent="center" mb={2}>
          <Icon icon="PhotoUploadFailed" />
        </Stack>
        <Type variant="sectionLabel" mb={1}>
          Photo upload failed
        </Type>
        <Type variant="data" mb={1}>
          The photo you uploaded was screened by our AI and identified as being
          inappropriate in nature.
        </Type>
        <Type variant="dataSmall" color="neutralCool_700">
          <strong>Reason(s)</strong>: {reasons.join(', ')}
        </Type>
      </Stack>
      <ModalActions>
        <TextButton
          onMouseUp={handleReopen}
        >
          Upload a new photo
        </TextButton>
        <TextButton
          color="neutralCool_700"
          onMouseUp={closeModal}
        >
          Sounds good
        </TextButton>
      </ModalActions>
    </ModalView>
  )
}

PhotoUploadFailed.propTypes = {
  reasons: PropTypes.array,
  reopenID: PropTypes.string,
}

PhotoUploadFailed.defaultProps = {
  reasons: [],
}

export default PhotoUploadFailed
